import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Tag } from '@repo/design-system/components/ui/tag';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectCurrentMapInfo, selectPlayerLocationDeltas } from '@repo/store/maps/slices/mapData';
import { useAuth } from '@repo/ui-web/auth/auth-hooks';
import { getUserAvatarUrl } from '@repo/utility/image-urls';
import type React from 'react';
import { useState } from 'react';
import { MapsAuthModal } from '../components/maps-auth-modal';
import { useSessionData } from '../game-map/hooks/useSessionData';
interface SessionHistorySectionProps {
  onClick: () => void;
}
export const SessionHistorySection: React.FC<SessionHistorySectionProps> = t0 => {
  const $ = _c(56);
  const {
    onClick
  } = t0;
  const {
    user
  } = useAuth();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const currentMap = useAppSelector(selectCurrentMapInfo);
  const playerLocationDeltas = useAppSelector(selectPlayerLocationDeltas);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const isLoggedIn = !!user;
  const supportsLiveLocation = !!playerLocationDeltas;
  const t2 = Number(currentMap?.titleId) || 0;
  const t3 = isLoggedIn && supportsLiveLocation;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = {
      titleId: t2,
      autoFetch: t3
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    totalCount
  } = useSessionData(t4);
  if (!supportsLiveLocation) {
    return null;
  }
  let T0;
  let avatarStyles;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== isLoggedIn || $[5] !== onClick) {
    const handleClick = () => {
      if (!isLoggedIn) {
        setIsLoginModalOpen(true);
      } else {
        onClick();
      }
    };
    const sectionStyles = css.raw({
      borderRadius: "8",
      width: "full",
      padding: "6",
      cursor: "pointer",
      transition: "[background-color 0.2s ease-in-out]",
      _hover: {
        backgroundColor: "whiteAlpha.10"
      }
    });
    let t10;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = css({
        width: "[20px]",
        height: "[20px]",
        borderRadius: "full",
        flexShrink: 0
      });
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    avatarStyles = t10;
    T0 = Button;
    t5 = "ghost";
    t6 = handleClick;
    t7 = "secondary";
    t8 = true;
    t9 = css(sectionStyles);
    $[4] = isLoggedIn;
    $[5] = onClick;
    $[6] = T0;
    $[7] = avatarStyles;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    T0 = $[6];
    avatarStyles = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[14] !== avatarStyles || $[15] !== t || $[16] !== user?.profileImage) {
    t10 = user?.profileImage ? <img loading="lazy" src={getUserAvatarUrl(user?.profileImage)} alt={t(_temp)} className={avatarStyles} width={20} height={20} /> : <Icon className={css({
      color: "text.secondary",
      minWidth: "[20px]"
    })} icon="person_outline" size="md" decorative={true} />;
    $[14] = avatarStyles;
    $[15] = t;
    $[16] = user?.profileImage;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t(_temp2);
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <Type variant="body-s">{t11}</Type>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t(_temp3);
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13) {
    t14 = <Tag variant="ghost">{t13}</Tag>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t12 || $[27] !== t14) {
    t15 = <FlexRow align="center" gap="12">{t12}{t14}</FlexRow>;
    $[26] = t12;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t || $[30] !== totalCount) {
    t16 = t(_temp4, {
      count: totalCount
    });
    $[29] = t;
    $[30] = totalCount;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <Type variant="body-xs">{t16}</Type>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t17) {
    t18 = <FlexColumn width="full">{t15}{t17}</FlexColumn>;
    $[34] = t15;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Icon icon="chevron_right" size="lg" decorative={true} className={css({
      color: "text.secondary"
    })} />;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t10 || $[39] !== t18 || $[40] !== t19) {
    t20 = <FlexRow gap="12" align="center" justify="between" width="full">{t10}{t18}{t19}</FlexRow>;
    $[38] = t10;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== T0 || $[43] !== t20 || $[44] !== t5 || $[45] !== t6 || $[46] !== t7 || $[47] !== t8 || $[48] !== t9) {
    t21 = <T0 variant={t5} onClick={t6} color={t7} fullWidth={t8} className={t9}>{t20}</T0>;
    $[42] = T0;
    $[43] = t20;
    $[44] = t5;
    $[45] = t6;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = details => setIsLoginModalOpen(details.open);
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== isLoginModalOpen) {
    t23 = <MapsAuthModal isOpen={isLoginModalOpen} onOpenChange={t22} trigger="timeline" size="sm" />;
    $[51] = isLoginModalOpen;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t21 || $[54] !== t23) {
    t24 = <>{t21}{t23}</>;
    $[53] = t21;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
};
function _temp($) {
  return $.user_avatar_alt;
}
function _temp2($_0) {
  return $_0.session_history.your_timeline;
}
function _temp3($_1) {
  return $_1.session_history.new_badge;
}
function _temp4($_2) {
  return $_2.session_history.sessions_count;
}